import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from '../Parts/Button'

import DialogModal from './DialogModal';

const styles = () => ({
  text: {
    marginBottom: '40px',
    textAlign: 'left',
  },

  button: {
    background: '#F03A47',
    '&:hover::before': {
      backgroundColor: '#F03A47',
      opacity: .6,
    }
  },

  contentContainer: {
    padding: '50px 40px',
    margin: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '450px',
    boxSizing: 'border-box',
    background: '#FFFFFF'
  },

  buttonContainer: {
    display: 'inline-flex',
    width: '100%',
    justifyContent: 'space-evenly',
  }
});

class ConfirmDialog extends React.Component {
  handleClick = () => {
    this.props.action();
    this.props.toggleDialog();
  }

  render() {
    const { classes, isOpen, toggleDialog, buttonText } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer
        }}
      >
        <Typography variant="subheading" className={classes.text}>
          この操作は元に戻せません。よろしいですか？
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={toggleDialog}
            text="キャンセル"
            type="ghost">
          </Button>
          <Button
            handleClickButton={this.handleClick}
            text={buttonText}
            loading={this.props.isLoading}>
          </Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  action: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  buttonText: PropTypes.string,
};

export default withStyles(styles)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/common/ConfirmDialog.jsx